<template>
	<div class="list-container column" style="padding: 0">
		<div class="title">{{ $t('buildings_list.title') }}</div>
		<div class="panel-list-header">
			<div class="panel-header-item">{{ $t('buildings_list.name') }}</div>
			<div v-if="!isMobile" class="panel-header-item">{{ $t('buildings_list.customer') }}</div>
			<div v-if="!isMobile" class="panel-header-item">{{ $t('buildings_list.floors') }}</div>
			<div class="panel-filler" v-if="$isAllowedTo('buildings_edit')" />
			<div class="panel-filler" v-if="$isAllowedTo('buildings_delete')" />
		</div>
		<div
			class="panel-list"
			:class="building.id == activeBuilding.id ? 'active' : ''"
			v-for="building in buildings"
			:key="building.id"
			@click="onSelect(building)"
		>
			<div class="panel-list-item">{{ building.name }}</div>
			<div v-if="!isMobile" class="panel-list-item">
				{{ building.customer.name }}
			</div>
			<div v-if="!isMobile" class="panel-list-item">
				{{ building.floors.length }}
				{{ building.floors.length != 1 ? $t('buildings_list.floors_plural') : $t('buildings_list.floor_singular') }}
			</div>
			<div
				class="list-button"
				v-if="$isAllowedTo('buildings_edit')"
				@click.stop="onEdit(building)"
			>
				<i class="fas fa-edit"></i>
			</div>
			<div
				v-if="$isAllowedTo('buildings_delete')"
				class="list-button"
				@click.stop="onDelete(building)"
			>
				<i class="fas fa-trash-alt"></i>
			</div>
			<div
				v-if="building.floors.length && ($isAllowedTo('buildings_edit') || $isAllowedTo('buildings_delete'))"
				class="list-button"
			></div>
		</div>
		<div class="panel-list no-hover" v-if="buildings.length == 0">
			<p class="panel-list-item">{{ $t('buildings_list.no_results') }}</p>
		</div>
		<Pagination
			v-if="buildings.length > 0"
			:pagination="pagination"
			@paginate="paginate"
			@updatePageSize="updatePageSize"
		/>
	</div>
</template>

<script>
import Pagination from '@/components/Pagination';
import { mapGetters, mapActions } from 'vuex';

export default {
	components: {
		Pagination
	},
	props: {
		buildings: Array,
		activeBuilding: Object
	},
	computed: {
		...mapGetters('buildingStore', ['pagination']),
		...mapGetters('appStore', ['isMobile'])
	},
	methods: {
		...mapActions('buildingStore', ['setCurrentPage', 'setPageSize']),
		onDelete(building) {
			if (!this.$isAllowedTo('buildings_delete')) return;
			this.$emit('delete', building);
		},
		onEdit(building) {
			if (!this.$isAllowedTo('buildings_edit')) return;
			this.$emit('edit', building);
		},
		onSelect(building) {
			this.$emit('navigate', building.id);
		},
		paginate(page) {
			this.setCurrentPage(page);
			this.$emit('search');
		},
		updatePageSize(size) {
			this.setPageSize(size);
			this.setCurrentPage(1);
			this.$emit('search');
		}
	}
};
</script>
